export default __webpack_public_path__ + "media/images/37-70e93bcf7abd22e8a03b8759bc31a92a.png";